/**
 * Function returns local language code in the form "cs-CZ" or "de-AT".
 */
export function getLanguage() {
    try { 
        // 1) Standard way to find the lang if <html> has lang attribute
        if (document.documentElement.getAttribute("lang")?.includes('-'))
            return document.documentElement.getAttribute("lang");
        // 2) Trying to find in Alza object
        return Alza.Shared.PageData.pageData.countryLocale.toString();
    }
    // 3) last approach when everything fails
    catch(e) { return Intl.DateTimeFormat().resolvedOptions().locale }
}